import React from 'react';

import Routes from './routes'

import './App.css';

const App = () => (
    <div className="App">
        <Routes />
    </div>
);

export default App;
